import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TrackJS } from 'trackjs';
import { ErrorReportingService } from '../_services/error-reporting.service';
import { shouldReportHttpError } from '../_utils/track-js.utils';

/**
 * Sole TrackJS reporter for HTTP failures.
 * User-facing toasts are owned by ErrorService / catchAndReport — not this interceptor.
 * Auth token attachment stays in InterceptorService.
 */
@Injectable()
export class TrackJsHttpInterceptor implements HttpInterceptor {
  private readonly errorReporting = inject(ErrorReportingService);

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse) {
          this.reportHttpError(error, req);
        }

        return throwError(() => error);
      })
    );
  }

  private reportHttpError(error: HttpErrorResponse, req: HttpRequest<unknown>): void {
    if (!this.errorReporting.isEnabled() || !TrackJS.isInstalled() || !shouldReportHttpError(error.status)) {
      return;
    }

    TrackJS.console.log({
      message: error.message,
      method: req.method,
      url: req.urlWithParams,
      status: error.status,
      statusText: error.statusText,
      response: error.error
    });

    // Wrap as Error so ErrorReportingService.shouldSkipError (HttpErrorResponse) does not drop it.
    const httpError = new Error(
      `HTTP ${error.status || 'NETWORK'}: ${req.method} ${req.urlWithParams} - ${error.statusText || error.message}`
    );

    this.errorReporting.report(httpError, { source: 'HttpInterceptor' });
  }
}
